import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { Loader } from '@accesa/react-core/build/animations/loader';

import { Logout } from './components/authentication/logout';
import { LogoutCallback } from './components/authentication/logoutCallback';
import { PrivateRoute } from './components/privateRoute/privateRoute';
import { Callback } from './components/authentication/callback';
import { SilentRenew } from './components/authentication/silentRenew';

import LoginRedirect from './pages/login/redirect';
import LoginPage from './pages/login';
import ROUTES from './routes';

import './styles.css';
import { AppContextProvider, defaultAppContext } from './AppContext';

const App: React.FC = (): React.ReactElement => {
  return (
    <Suspense fallback={<Loader id={'app-loader'} color={'orange'} />}>
      <Router>
        <AppContextProvider value={defaultAppContext}>
          {ROUTES.privateRoutes.map((routeProps) => (
            <PrivateRoute {...routeProps} />
          ))}
        </AppContextProvider>
        <Route path="/callback" exact>
          <Callback />
        </Route>
        <Route path="/login" exact>
          <LoginPage />
        </Route>
        <Route path="/loginWithExtranet" exact>
          <LoginRedirect />
        </Route>
        <Route path="/logout" exact>
          <Logout />
        </Route>
        <Route path="/logout/callback" exact>
          <LogoutCallback />
        </Route>
        <Route path="/silentrenew" exact>
          <SilentRenew />
        </Route>
      </Router>
    </Suspense>
  );
};

export default App;
